import React, { FC, useCallback, useState, useEffect } from 'react'
import { createStyles, makeStyles } from '@material-ui/core'
import Store from 'store'
import { validatePhone } from '@utils'

import TextField from '@components/TextField'
import AreaSelect from '@components/AreaSelect'
import AppListDialog, { dataType } from './AppListDialog'
import fork from './img/fork.png'
import hide from './img/hide.png'
import show from './img/show.png'
import { transform } from '@utils/intl_lang'
export type UnionLabelType = 'areaCode' | 'username' | 'password'
export type OnChangeType = (label: UnionLabelType, value: string) => void

interface IProps {
  usernameOrPwdError: boolean
  username?: string
  password?: string
  identityCodeError: boolean
  onChange: (label: string, value: string | number) => void
  appListDialogVisible: boolean
  appList: dataType
  dialogTitle: string
  loginLoading: boolean
  onClose: () => void
  onSelectApp: (appId: string) => () => void
  isCancelLogin: boolean
  resetLogin: () => void
  isPasswordType: boolean
}

const PasswordLoginForm: FC<IProps> = ({
  isCancelLogin,
  usernameOrPwdError,
  ...props
}) => {
  const [username, setUsername] = useState(props.username || '')
  const [password, setPassword] = useState('')
  const [phoneError, setPhoneErr] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const classes = useStyles()
  const area = Store.get('areaCode')

  const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const val =
      area && +area !== 86
        ? !event.target.value.trim()
        : !validatePhone(event.target.value)
    setPhoneErr(val)
  }

  const onChange = useCallback(
    (label: UnionLabelType) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
      switch (label) {
      case 'username':
        setUsername(value)
        break
      case 'password':
        setPassword(value)
        break
      }
      props.onChange(label, value)
    },
    [username]
  )

  const onAreaChange = (v: string) => {
    const code = (v !== '86' && v) || ''
    if (code) {
      setPhoneErr(!username)
    } else {
      setPhoneErr(!validatePhone(username))
    }
    Store.set('areaCode', code)
  }

  const onAccountChange = () => {
    setUsername('')
  }

  const togglePasswordShow = () => {
    setShowPassword(!showPassword)
  }

  useEffect(() => {
    if (isCancelLogin) {
      props.resetLogin()
    }
  }, [isCancelLogin])

  return (
    <>
      <div className={classes.accountContainer}>
        <AreaSelect onChange={onAreaChange} />
        <TextField
          type="number"
          // '手机号格式错误' : '手机号'
          label={
            phoneError
              ? transform('Login_wrong_format_number')
              : transform('Login_mobile_number')
          }
          placeholder="请输入手机号"
          value={username}
          onChange={onChange('username')}
          onBlur={onBlur}
          error={phoneError}
          className={classes.name}
          InputClass={{ formControl: classes.inputText }}
        />
        {username.length ? (
          <div
            className={classes.icon}
            onClick={onAccountChange}
          >
            <img style={{ width: '17.5px', height: '17.5px' }} src={fork} alt="" />
          </div>
        ) : null}
      </div>
      <div className={classes.accountContainer}>
        <TextField
          id="standard-password-input"
          // "密码"
          label={transform('Login_pwd')}
          placeholder="请输入密码"
          className={classes.textField}
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={onChange('password')}
          error={usernameOrPwdError}
        />
        <div
          className={classes.icon}
          onClick={togglePasswordShow}
        >
          <img
            style={{ width: '17.5px', height: '17.5px' }}
            src={showPassword ? show : hide}
          />
        </div>
      </div>
      {props.appListDialogVisible && (
        <AppListDialog
          data={props.appList}
          title={props.dialogTitle}
          loading={props.loginLoading}
          handleClose={props.onClose}
          handleSelect={props.onSelectApp}
        />
      )}
    </>
  )
}

const useStyles = makeStyles(() =>
  createStyles({
    accountContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      position: 'relative',
      height: 60,
      marginTop: 25,
    },
    inputText: {
      paddingLeft: 68,
    },
    name: {
      position: 'absolute',
      bottom: '0px',
      left: '0px',
      width: '460px',
      marginTop: '25px',
      marginBottom: 0,
    },
    textField: {
      width: '460px',
      marginTop: '25px',
      marginBottom: 0,
    },
    icon: {
      position: 'absolute',
      bottom: '10px',
      right: '75px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    }
  })
)

export default PasswordLoginForm
